import React from 'react';
import PropTypes from 'prop-types';
import IndeterminateCurrencyInput from '../../../../../common/indeterminateCurrencyInput';
import SimpleCheckbox from '../../../../../common/simpleCheckbox';
import ToolTip from '../../../../../common/tooltip';
import MinServiceLenSelect from '../../MinServiceLenSelect';
import BarberBookingInterval from '../../BarberBookingInterval';
import AdvanceBookingForm from '../../../../../common/advanceBookingForm';
import Passcode from '../../Passcode';
import withCanModifyBarber from './withCanModifyBarber';
import { TIME_TRACKING_ROLES } from '../../../../constants';

const Options = ({
  shopBookNoPay,
  canUsePasscode,
  canCustomerCancel,
  extendedHourlyWagesEnabled,
  calculateHourlyWagesEnabled,
  barberUser,
  canModify,
  minInterval,
}) => (
  <div className="u-mv">
    <fieldset disabled={!canModify}>
      <div className="layout">
        <div className="c-heading c-heading--lightgrey c-wrapper u-pv0 u-mb u-ml">Options</div>
        <div className="layout__item u-1/2">
          <div className="u-mb u-ml+">
            <SimpleCheckbox
              name="bookNoPay"
              id="bookNoPay"
              label="Allow booking without payment"
              display-if={shopBookNoPay}
            />
            <SimpleCheckbox
              name="tipEnabled"
              id="tipEnabled"
              label={(
                <>
                  Booking tip&nbsp;
                  <ToolTip text="Displays tipping during the booking flow" />
                </>
              )}
              wrapperClass="u-mt-"
            />
            <SimpleCheckbox
              name="lateTipping"
              id="lateTipping"
              wrapperClass="u-mt-"
              label={(
                <>
                  Confirmation Tip&nbsp;
                  <ToolTip text="Displays tipping on the confirmation page" />
                </>
              )}
            />
            <SimpleCheckbox
              name="allowMultipleServices"
              id="allowMultipleServices"
              label="Allow multiple services"
              wrapperClass="u-mt-"
            />
            <SimpleCheckbox
              name="trackEmployeeTime"
              id="trackEmployeeTime"
              label="Track employee time"
              wrapperClass="u-mt-"
            />
          </div>
          <div className="u-ml">
            <AdvanceBookingForm canCustomerCancel={canCustomerCancel} minInterval={minInterval} />
          </div>
        </div>
        <div className="layout__item u-1/2">
          <MinServiceLenSelect minInterval={minInterval} />
          <BarberBookingInterval minInterval={minInterval} />
          <div className="c-separator u-mb-" display-if={canUsePasscode} />
          <Passcode display-if={canUsePasscode} />
          <div display-if={calculateHourlyWagesEnabled && !barberUser} className="u-mt layout__item">
            <div display-if={!extendedHourlyWagesEnabled} className="u-width-120">
              <div className="c-label c-label--light">Hourly wage</div>
              <IndeterminateCurrencyInput className="c-input" name="hourlyWage" />
            </div>
            <div display-if={extendedHourlyWagesEnabled}>
              <div className="c-heading c-heading--lightgrey c-wrapper u-p0 u-mb-">Hourly wage</div>
              <div className="o-flexbox u-pr">
                <div className="u-width-120">
                  <div className="c-label c-label--light">Barber</div>
                  <IndeterminateCurrencyInput className="c-input" name="hourlyWage" />
                </div>
                <div className="u-width-120">
                  <div className="c-label c-label--light">Meetings</div>
                  <IndeterminateCurrencyInput className="c-input" name="meetingHourlyWage" />
                </div>
                <div className="u-width-120">
                  <div className="c-label c-label--light">Manager</div>
                  <IndeterminateCurrencyInput className="c-input" name="managerHourlyWage" />
                </div>
              </div>
            </div>
          </div>
          <div display-if={extendedHourlyWagesEnabled && !barberUser} className="u-mt layout__item">
            <div className="c-heading c-heading--lightgrey c-wrapper u-p0 u-mb-">Clock in Roles</div>
            { Object.values(TIME_TRACKING_ROLES).map(role => (
              <SimpleCheckbox
                name={`timeTrackRoles.${role.field}`}
                id={`timeTrackRoles.${role.field}`}
                label={role.label}
              />
            ))}
          </div>
        </div>
      </div>
    </fieldset>
  </div>
);

Options.propTypes = {
  shopBookNoPay: PropTypes.bool.isRequired,
  canUsePasscode: PropTypes.bool.isRequired,
  calculateHourlyWagesEnabled: PropTypes.bool.isRequired,
  extendedHourlyWagesEnabled: PropTypes.bool.isRequired,
  canCustomerCancel: PropTypes.bool,
  barberUser: PropTypes.object,
  canModify: PropTypes.bool,
  minInterval: PropTypes.number,
};

Options.defaultProps = {
  barberUser: null,
  canModify: true,
  canCustomerCancel: false,
  minInterval: null,
};

export default withCanModifyBarber(Options);
